import { useMutation } from '@tanstack/react-query';
import { addPassword } from '@/features/auth/services/invitation';
import { getOnboardingToken } from '@/shared/api/storage';
import type { AddPasswordRequest } from '@/features/auth/types/invitation.types';

interface UseAddPasswordOptions {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}

/**
 * Sets the password of an invited / first-access user.
 *
 * Authorized by the in-memory onboarding token issued by the previous step
 * (`/users/register-invitation` or `/auth/identify?firstaccess=true`).
 */
export function useAddPassword(options?: UseAddPasswordOptions) {
  return useMutation<void, Error, AddPasswordRequest>({
    mutationFn: (payload) => {
      const accessToken = getOnboardingToken();
      if (!accessToken) {
        return Promise.reject(new Error('Missing onboarding session'));
      }
      return addPassword(payload, accessToken);
    },
    onSuccess: () => {
      options?.onSuccess?.();
    },
    onError: (error) => {
      options?.onError?.(error);
    },
  });
}
